import { useEffect, useState } from "react";
import { Flame } from "lucide-react";

const TRIP_START = new Date("2026-11-21T06:00:00+05:30");

const remaining = () => {
  const diff = Math.max(0, TRIP_START - Date.now());
  const s = Math.floor(diff / 1000);
  return { days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60, started: diff === 0 };
};

export const TripCountdown = () => {
  const [t, setT] = useState(remaining);
  useEffect(() => {
    const id = setInterval(() => setT(remaining()), 1000);
    return () => clearInterval(id);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");
  return (
    <div className="dt-countdown-wrap dt-rise d3" data-testid="deoria-countdown">
      {t.started ? (
        <p className="dt-count-live">The mountains are calling - we&#39;re on our way.</p>
      ) : (
        <div className="dt-count" aria-label={`${t.days} days to go`}>
          <div className="dt-count-cell"><strong data-testid="deoria-countdown-days">{t.days}</strong><span>days</span></div>
          <div className="dt-count-cell"><strong>{pad(t.hours)}</strong><span>hrs</span></div>
          <div className="dt-count-cell"><strong>{pad(t.minutes)}</strong><span>min</span></div>
          <div className="dt-count-cell"><strong>{pad(t.seconds)}</strong><span>sec</span></div>
          <p className="dt-count-label">to go</p>
        </div>
      )}
      <p className="dt-spots" data-testid="deoria-spots-nudge"><Flame size={14} /> Small group - only a few spots left</p>
    </div>
  );
};
